import { isWeb } from "@tamagui/constants";
const groupEnd = console.groupEnd.bind(console),
  gc = console.groupCollapsed.bind(console),
  groupCollapsed = isWeb ? gc : console.info;
export { groupCollapsed, groupEnd };
//# sourceMappingURL=consoleLog.mjs.map
